<div class="info-business card-white-panel">
    <form [formGroup]="venueForm">
        <div class="d-flex flex-wrap conteiner-info-venue">
            <div class="container-in-page col-8">
                <div class="col-info-business col-12">
                    <div class="d-flex align-items-center title-info-business">
                        <p class="m-0">Nombre del espacio<span class="required-field">*</span></p>
                    </div>
                    <div>
                        <div
                            class="bloque-change-input container-form d-flex align-items-center password-input"
                            [ngClass]="{
                                error: venueForm.get('name')?.invalid && venueForm.get('name')?.touched
                            }">
                            <input class="w-100" type="text" placeholder="Nombre" formControlName="name"
                                (change)="onNameChange()" required />
                        </div>
                        <p class="field-error-text"
                           *ngIf="venueForm.get('name')?.invalid && venueForm.get('name')?.touched">
                            Este campo es obligatorio.
                        </p>
                    </div>
                </div>
                <div class="col-info-business col-12">
                    <div class="d-flex align-items-center title-info-business">
                        <p class="m-0">URL personalizada<span class="required-field">*</span></p>
                    </div>
                    <div>
                        <div
                            class="bloque-change-input container-form d-flex align-items-center password-input"
                            [ngClass]="{
                                error: venueForm.get('slug')?.invalid && venueForm.get('slug')?.touched
                            }">
                            <input
                                class="w-100"
                                type="text"
                                placeholder="nuevo-slug-unico"
                                formControlName="slug"
                                (input)="cleanSlug()" />
                        </div>
                        <p class="field-error-text"
                           *ngIf="venueForm.get('slug')?.invalid && venueForm.get('slug')?.touched">
                            Este campo es obligatorio.
                        </p>
                    </div>
                </div>

                <div class="col-info-business col-12">
                    <div class="d-flex align-items-center title-info-business">
                        <p class="m-0">Localización<span class="required-field">*</span></p>
                    </div>
                    <div class="section-search-map">
                        <mat-form-field appearence="fill" class="w-100 label-title pointer-in">
                            <input id="searchMap" #search matInput
                                class="pointer-in bloque-change-input container-form"
                                [ngClass]="{
                                    error: venueForm.get('address')?.invalid && venueForm.get('address')?.touched
                                }"
                                type="text" placeholder="Buscar localización..." [(ngModel)]="lugar" name="location"
                                (input)="onSearchPlaces()" (blur)="onBlurAddress()" [matAutocomplete]="auto"
                                [ngModelOptions]="{ standalone: true }" />
                            <mat-autocomplete (optionSelected)="onSelectPlace(search.value)" #auto="matAutocomplete"
                                [displayWith]="displayFn">
                                <mat-option *ngFor="let option of searchResults" [value]="option"
                                    class="item-option-map">
                                    <div class="item-option">
                                        <i class="fa-solid fa-location-dot"></i>
                                        <span class="">{{ option.description }}</span>
                                    </div>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <p class="field-error-text"
                       *ngIf="venueForm.get('address')?.invalid && venueForm.get('address')?.touched">
                        Este campo es obligatorio.
                    </p>
                </div>
                <div class="col-info-business col-12">
                    <div class="d-flex align-items-center title-info-business">
                        <p class="m-0">Descripción del espacio<span class="required-field">*</span></p>
                    </div>
                    <div>
                        <div
                            class="bloque-change-input input-address container-form d-flex align-items-center password-input"
                            [ngClass]="{
                                error: venueForm.get('description')?.invalid && venueForm.get('description')?.touched
                            }">
                            <textarea #textarea class="w-100" type="textarea" placeholder="Descripción" maxlength="2500"
                                formControlName="description"></textarea>
                        </div>
                        <p class="field-error-text"
                           *ngIf="venueForm.get('description')?.invalid && venueForm.get('description')?.touched">
                            Este campo es obligatorio.
                        </p>
                    </div>
                </div>
                <div class="col-info-business col-12" *ngIf="!openedCreateMap">
                    <div class="d-flex align-items-center title-info-business">
                        <p class="m-0">Aforo<span class="required-field">*</span></p>
                    </div>
                    <div>
                        <div
                            class="bloque-change-input container-form d-flex align-items-center password-input"
                            [ngClass]="{
                                error: venueForm.get('capacity')?.invalid && venueForm.get('capacity')?.touched
                            }">
                            <input class="w-100" type="number" placeholder="Aforo del espacio"
                                formControlName="capacity" required />
                        </div>
                        <p class="field-error-text"
                           *ngIf="venueForm.get('capacity')?.invalid && venueForm.get('capacity')?.touched">
                            Este campo es obligatorio.
                        </p>
                    </div>
                </div>
                <div class="col-info-business col-12">
                    <div class="d-flex align-items-center title-info-business">
                        <p class="m-0">Mapa de butacas</p>
                    </div>
                    <div *ngIf="openedCreateMap">
                        <p>
                            Podrás añadir los niveles (Patio de butacas, 1º Anfiteatro, etc),
                            las secciones (Impares, Pares, Platea 1, etc) y las butacas desde
                            el siguiente creador.
                        </p>
                    </div>
                    <div class="conteiner-map-venue" *ngIf="!openedCreateMap">
                        <p>
                            Para crear un mapa de butacas, por favor, ponte en contacto con
                            los administradores de Citylok.
                        </p>
                        <!-- <div class="btns-create">
                            <div class="btn-create btn-bono m-0" [class.disabled]="!allowSuperAdmin" (click)="allowSuperAdmin && createMap()">
                                <i class="fal fa-plus-circle"></i>
                                <p class="m-0">Crear mapa de butacas</p>
                            </div>
                        </div> -->
                    </div>
                </div>
        <div class="col-info-business col-12">
                    <div class="d-flex align-items-center title-info-business">
                        <p class="m-0">Condiciones generales</p>
                    </div>
                    <div>
                        <div class="bloque-change-input input-address container-form d-flex align-items-center password-input">
                            <textarea #textareaConds class="w-100" type="textarea" placeholder="Condiciones de uso o contratación..." maxlength="5000"
                                formControlName="general_conditions"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 col-image-business">
                <div class="d-flex align-items-center justify-content-center" style="gap: 10px; margin-bottom: 5px">
                    <p class="title-image m-0">FOTO DE PORTADA<span class="required-field">*</span></p>
                    <i class="fas fa-circle-info icon-primary pointer-in"
                        matTooltip="Será la imágen que se muestre en la vista del espacio."></i>
                </div>
                <div class="container-image" (click)="file.click()">
                    <div class="not-image-business"
                         [ngClass]="{
                            error: venueForm.get('file')?.invalid && venueForm.get('file')?.touched
                         }">
                        <i class="fa-thin fa-image" *ngIf="!imgControl.value"></i>
                        <img [src]="imgControl.value" alt="Img espacio" *ngIf="imgControl.value" />
                    </div>
                    <input id="file" #file hidden type="file" accept="image/*" (change)="onFileChange($event)" />
                    <div class="circle-add-image">
                        <i class="fa-light fa-plus"></i>
                    </div>
                    <p class="image-error-text"
                       *ngIf="venueForm.get('file')?.invalid && venueForm.get('file')?.touched">
                        La foto de portada es obligatoria.
                    </p>
                </div>
            </div>
            <div class="container-map-venue col-12" *ngIf="openedCreateMap">
                <app-create-map [fromVenue]="true" [allowCreate]="true"></app-create-map>
            </div>
        </div>
        <!-- <mat-divider></mat-divider> -->
        <div class="container-in-page" *ngIf="false">
            <div class="col-info-business col-12">
                <div class="d-flex align-items-center title-info-business">
                    <mat-checkbox class="pointer-in" formControlName="allow_subscription"></mat-checkbox>
                    <p class="m-0 disabled-title">Permitir suscriptores</p>
                </div>
            </div>
            <div class="col-12">
                <div class="col-info-business col-12">
                    <div class="d-flex align-items-center title-info-business">
                        <p class="m-0">Nombre de subscriptores</p>
                    </div>
                    <div>
                        <div class="bloque-change-input container-form d-flex align-items-center password-input">
                            <input class="w-100" type="text" placeholder="Nombre de los miembros"
                                formControlName="membership_title" required />
                        </div>
                    </div>
                </div>
                <div class="col-info-business col-12">
                    <div class="d-flex align-items-center title-info-business">
                        <p class="m-0">Texto de suscripción</p>
                    </div>
                    <div>
                        <div class="bloque-change-input container-form d-flex align-items-center password-input">
                            <input class="w-100" type="text" placeholder="Texto de suscripción"
                                formControlName="subscription_text" required />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="container-in-page">
        <div class="btn-create m-0" (click)="!loading && saveVenue()" [class.disabled]="loading">
            <i class="fal" [ngClass]="loading ? 'fa-spinner fa-spin' : 'fa-save'"></i>

            <p class="m-0">{{ loading ? "Procesando..." : "Crear espacio" }}</p>
        </div>
    </div>
    <!-- <mat-divider></mat-divider>
        <div class="container-in-page">
            <div class="btn-create m-0" (click)="updateFile()">
                <i class="fal fa-plus-circle"></i>
                <p class="m-0">Subir programación</p>
            </div>
        </div> -->
</div>